var _possibleConstructorReturn = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

/**
 * Local dependencies
 */
var _require = require('@solid/jose'),
    JWT = _require.JWT;

var REQUIRED_CLAIMS = ['iss', 'sub', 'aud', 'exp', 'iat'];

var TokenClaimsSet = /*#__PURE__*/function () {
  "use strict";

  /**
   * Claims inherited from JWT:
   * @param iss {string} Issuer URL
   * @param sub {string} Subject identifier
   * @param aud {string|Array<string>} Audience
   * @param exp {number} Expiration (seconds since epoch, RFC3339)
   * @param iat {number} Expiration (seconds since epoch, RFC3339)
   * @param [nbf] {number} Not Before (seconds since epoch, RFC3339)
   * @param [jti] {string} JWT Identifier
   *
   * Claims specific to ID Token:
   * @param [auth_time] {number} Time when user authn occurred (RFC3339)
   * @param [nonce] {string}
   * @param [acr] {string} Authentication Context Class Reference
   * @param [amr] {string} Authentication Methods References
   * @param [azp] {string} Authorized party
   */
  function TokenClaimsSet() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        iss = _ref.iss,
        sub = _ref.sub,
        aud = _ref.aud,
        exp = _ref.exp,
        iat = _ref.iat,
        nbf = _ref.nbf,
        jti = _ref.jti,
        auth_time = _ref.auth_time,
        nonce = _ref.nonce,
        acr = _ref.acr,
        amr = _ref.amr;

    _classCallCheck(this, TokenClaimsSet);

    this.iss = iss;
    this.sub = sub;
    this.aud = aud;
    this.exp = exp;
    this.iat = iat;
    this.nbf = nbf;
    this.jti = jti;
    this.auth_time = auth_time;
    this.nonce = nonce;
    this.acr = acr;
    this.amr = amr;
  }

  _createClass(TokenClaimsSet, [{
    key: "validate",
    value: function validate() {
      var valid = true;
      var error;

      try {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = REQUIRED_CLAIMS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var claim = _step.value;

            if (!this[claim]) {
              valid = false;
              throw new Error("Required claim ".concat(claim, " is missing."));
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } catch (validationError) {
        error = validationError;
      }

      return {
        valid: valid,
        error: error
      };
    }
  }]);

  return TokenClaimsSet;
}();
/**
 * IDToken
 */


var IDToken = /*#__PURE__*/function (_JWT) {
  "use strict";

  _inherits(IDToken, _JWT);

  function IDToken() {
    var _this;

    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, IDToken);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IDToken).call(this, data));
    _this.payload = new TokenClaimsSet(data.payload);
    return _this;
  }

  _createClass(IDToken, [{
    key: "validate",
    value: function validate() {
      var payloadResult = this.payload.validate();

      if (!payloadResult.valid) {
        return payloadResult;
      }

      var valid = true;
      var error;
      return {
        valid: valid,
        error: error
      };
    }
  }]);

  return IDToken;
}(JWT);
/**
 * Export
 */


module.exports = IDToken;
module.exports.TokenClaimsSet = TokenClaimsSet;